import { openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 980.2 307.4"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("switch", null, [
      _createElementVNode("foreignObject", {
        width: "1",
        height: "1",
        x: "0",
        y: "0",
        requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
      }),
      _createElementVNode("g", null, [
        _createElementVNode("g", { fill: "#FFF" }, [
          _createElementVNode("path", { d: "M91.5 102.6H111V144h52.7v-41.4h19.5V205h-19.5v-42.6H111V205H91.5zM207.2 153.8c0-30.1 23-53.1 54-53.1s54 23.3 54 53.1c0 30.1-23.1 53.1-54.1 53.1s-53.9-22.7-53.9-53.1m87.7 0c0-19.6-14.1-34.5-33.7-34.5-19.8 0-33.8 14.9-33.8 34.5 0 19.9 14 34.5 33.8 34.5 19.6 0 33.7-14.6 33.7-34.5M334.1 153.8c0-30.1 22.2-53.1 53.6-53.1 25.2 0 43.6 13.5 49.2 34.1h-21.4c-4.1-10.2-14.3-15.5-27.8-15.5-20 0-33.4 14.8-33.4 34.5 0 20.1 13.5 35 33.5 35 16.7 0 29.2-9.8 30.6-21.4h-32.5v-16.1H440c.7 34.9-21.5 55.6-52.2 55.6-31.5 0-53.7-22.7-53.7-53.1M580.3 102.6h53c20.9 0 35.3 13.3 35.3 32.6 0 14.2-8.3 25-19.2 29.9l22.5 39.9h-21.8l-19.2-36.6h-31.2V205h-19.5V102.6zm51.5 49.1c9.7 0 16.8-5.7 16.8-16.5 0-9.2-6.3-16-17.1-16h-31.7v32.5zM721 119.7h-36v-17.1h91.6v17.1h-36.2V205H721zM797 102.6h19.5V144h52.7v-41.4h19.5V205h-19.5v-42.6h-52.7V205H797zM518.5 102.6h-24.6L450.1 205h20.1l8.9-20.2h54.3l8.9 20.2h20.1zm-32 64.8 18.8-43.2h1.8l18.8 43.2z" })
        ])
      ])
    ], -1)
  ])))
}
export default { render: render }